import type { HeaderContent } from '@mawkaa/types';
import { Button } from '@mawkaa/ui';
import { Menu } from 'lucide-react';
import { cn } from '@mawkaa/ui';

interface HeaderBlockProps {
  content: HeaderContent;
  isEditing?: boolean;
}

export function HeaderBlock({ content, isEditing }: HeaderBlockProps) {
  const { logo, logoText, navigation = [], showCta, ctaText, ctaLink, style = 'simple' } = content;

  return (
    <header className="border-b bg-white">
      <div className={cn(
        'max-w-6xl mx-auto px-4 py-4 flex items-center',
        style === 'centered' && 'justify-center flex-col gap-4',
        style === 'simple' && 'justify-between',
        style === 'split' && 'justify-between'
      )}>
        {/* Logo */}
        <div className="flex items-center gap-2">
          {logo ? (
            <img src={logo} alt={logoText || 'Logo'} className="h-8" />
          ) : (
            <span className="text-xl font-bold">{logoText || 'Mon Site'}</span>
          )}
        </div>

        {/* Navigation */}
        <nav className={cn(
          'hidden md:flex items-center gap-6',
          style === 'centered' && 'order-last'
        )}>
          {navigation.map((item, index) => (
            <a
              key={index}
              href={isEditing ? '#' : item.link}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* CTA Button */}
        {showCta && ctaText && (
          <Button size="sm" className="hidden md:inline-flex">
            {ctaText}
          </Button>
        )}

        {/* Mobile menu button */}
        <Button variant="ghost" size="icon" className="md:hidden">
          <Menu className="w-5 h-5" />
        </Button>
      </div>
    </header>
  );
}
